PES = PES || {}
PES.CookieConset = function () {
    var init = function () {
        $(document).ready(function () {
            const isOldCookiePresent = document.cookie.indexOf("cookieconsent_status") > 0;
            const oldCookieBanner = document.getElementById("cookie-banner");
            let dimissCookie = document.getElementById('cookie_consent--dismiss');

            const addOldCookie = function () {
                let date = new Date();
                date.setFullYear(date.getFullYear() + 1);
                const expires = "expires=" + date.toUTCString();
                document.cookie = "cookieconsent_status=dismiss; " + expires + "; path=/";
                oldCookieBanner.classList.remove("show-banner");
                dimissCookie.removeEventListener('click', addOldCookie);
            };

            const showCookieBotBanner = function () {
                const showOldBanner = window.Cookiebot?.isOutOfRegion;
                if (showOldBanner && !isOldCookiePresent) {
                    oldCookieBanner.classList.add("show-banner");
                    dimissCookie.addEventListener('click', addOldCookie);
                }
            }

            window.addEventListener("CookiebotOnDialogInit", showCookieBotBanner);
            window.addEventListener("CookiebotOnLoad", showCookieBotBanner);
        });        

        return function () {
            window.removeEventListener("CookiebotOnDialogInit", showCookieBotBanner);
            window.removeEventListener("CookiebotOnLoad", showCookieBotBanner);
        }
    }
    return {
        init: init
    }
}();

